import { handleRequest } from "../utilities/requestHandler";

export const setUserPassword = (userId, password, confirmPassword) =>
    handleRequest("post", "/users/setpassword", { userId, pass: password, c_pass: confirmPassword });